import Api from '~/store/idonia-api/api'
import {useBusUtils} from '~/commons/busUtils'
import bus from '~/bus'

export function useBackEvents () {
  let sockets = Api ? Api.getWebsockets() : new Map()
  const {replaceHandler} = useBusUtils()
  replaceHandler(bus, 'loadedSocket', (sock) => {
    sockets = sock
  })

  function subscribe (events, channels, handler) {
    if (!events) {
      return
    }
    const {e, ch} = getAsArray(events, channels)
    for (const key of sockets.keys()) {
      let socket = sockets.get(key)
      if (!socket._channels) {
        socket._channels = new Map()
      }
      for (let i = 0; i < ch.length; i++) {
        for (let j = 0; j < e.length; j++) {
          _subscribe(socket, e[j], ch[i], handler)
        }
      }
    }
    return function () {
      unsubscribe(e, ch, handler)
    }
  }

  function _subscribe (socket, event, channel, handler) {
    if (!socket._channels.has(channel)) {
      socket._channels.set(channel, new Map())
      socket.emit('join', channel)
      console.log(socket, 'join', channel)
    }
    socket.off(event, handler)
    socket.on(event, handler)
    socket._channels.get(channel).set(event, pushHandler(socket._channels.get(channel).get(event), handler))
  }

  function unsubscribe (events, channels, handler) {
    let unsubscribeFunction = (socket, event, channel, handler) => { _unsubscribe(socket, event, channel, handler) }
    if (!handler) {
      unsubscribeFunction = (socket, event, channel) => { _unsubscribeFromEvent(socket, event, channel) }
    }
    for (const key of sockets.keys()) {
      let socket = sockets.get(key)
      let chan = channels
      if (!channels) {
        chan = getChannels(socket)
      }
      const {e, ch} = getAsArray(events, chan)
      for (let i = 0; i < ch.length; i++) {
        for (let j = 0; j < e.length; j++) {
          unsubscribeFunction(socket, e[j], ch[i], handler)
        }
      }
    }
  }

  function _unsubscribe (socket, event, channel, handler) {
    if (socket._channels.has(channel)) {
      socket._channels.get(channel).set(event, removeHandler(socket._channels.get(channel).get(event), handler))
      socket.off(event, handler)
      if (socket._channels.get(channel).get(event) && socket._channels.get(channel).get(event).length === 0) {
        socket._channels.get(channel).delete(event)
      }
      if (socket._channels.get(channel).size === 0) {
        socket._channels.delete(channel)
        stopListening(channel, socket)
      }
    }
  }

  function _unsubscribeFromEvent (socket, event, channel) {
    if (socket._channels.has(channel)) {
      if (socket._channels.get(channel).has(event)) {
        socket.off(event)
        socket._channels.get(channel).delete(event)
        if (socket._channels.get(channel).size === 0) {
          socket._channels.delete(channel)
          stopListening(channel, socket)
        }
      }
    }
  }

  function stopListening (channel, socket) {
    socket.emit('leave', channel)
  }

  function getChannels (socket) {
    return socket._channels ? Array.from(socket._channels.keys()) : []
  }
  function removeHandler (handlers, h) {
    let cb
    let hs = handlers || []
    for (var i = 0; i < hs.length; i++) {
      cb = hs[i]
      if (cb === h) {
        hs.splice(i, 1)
        return hs
      }
    }
  }

  function pushHandler (handlers, h) {
    let cb
    let hs = handlers || []
    for (var i = 0; i < hs.length; i++) {
      cb = hs[i]
      if (cb === h) {
        hs[i] = h
        return hs
      }
    }
    hs.push(h)
    return hs
  }

  function getAsArray (events, channels) {
    let e = []
    if (Array.isArray(events)) {
      e = events
    } else {
      e.push(events)
    }
    let ch = []
    if (Array.isArray(channels)) {
      ch = channels
    } else {
      ch.push(channels)
    }
    return {
      e,
      ch
    }
  }

  return {
    subscribe,
    unsubscribe
  }
}



// WEBPACK FOOTER //
// ./src/commons/events.js